module.exports = __webpack_public_path__ + "img/main-label.8460b33.svg";